<template>
  <TableCartBase
    :items="items"
    :container-classes="[
      'fixed top-0 right-0 h-full w-full max-w-md bg-white shadow-2xl transform transition-transform duration-300 ease-in-out flex flex-col',
      isOpen ? 'translate-x-0' : 'translate-x-full'
    ]"
    container-style="z-index: 60"
    :show-pin-button="true"
    pin-button-type="pin"
    :show-close-button="true"
    :is-store-closed="isStoreClosed"
    @pin="handlePin"
    @update-quantity="onUpdateQuantity"
    @remove-item="$emit('remove-item', $event)"
    @edit-item="$emit('edit-item', $event)"
    @checkout="$emit('checkout')"
    @view-check="$emit('view-check')"
    @close="$emit('close')"
  >
    <!-- Overlay -->
    <template #overlay>
      <div
        :class="[
          'fixed inset-0 bg-black/50 backdrop-blur-sm transition-opacity',
          isOpen ? 'opacity-100' : 'opacity-0'
        ]"
        :style="
          isOpen
            ? 'z-index: 55; pointer-events: auto;'
            : 'z-index: 55; pointer-events: none;'
        "
        @click="$emit('close')"
      />
    </template>
  </TableCartBase>
</template>

<script>
import TableCartBase from "./TableCartBase.vue";

export default {
  name: "TableCartDrawer",
  components: {
    TableCartBase
  },
  props: {
    isOpen: {
      type: Boolean,
      default: false
    },
    items: {
      type: Array,
      default: () => []
    },
    isStoreClosed: {
      type: Boolean,
      default: false
    }
  },
  emits: [
    "update-quantity",
    "remove-item",
    "edit-item",
    "checkout",
    "view-check",
    "close",
    "pin"
  ],
  methods: {
    handlePin() {
      this.$emit("pin");
      this.$emit("close");
    },
    onUpdateQuantity(cartId, delta) {
      this.$emit("update-quantity", cartId, delta);
    }
  }
};
</script>
